export default {
    firmware_tab_version: "Firmware Version",
    firmware_tab_hardware_version: "Hardware Version",
    firmware_tab_status: "Status",
    firmware_tab_default: "Default",
    firmware_tab_firmware_type: "Firmware Type",
    firmware_tab_description: "Description",
    firmware_tab_release_time: "Release Time",
    firmware_tab_label: "Refresh the Firmware Versions",
    firmware_tab_active: "Active",
    firmware_tab_deactivated: "Deactivated",
    firmware_tab_yes: "Yes",
    firmware_tab_no: "No",
    firmware_tab_assign_firmware_to: "Assign Firmware To",
    firmware_tab_update_vidfleet_devices: "Update Vidfleet Devices"
}